import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface DailyCardState {
  open: boolean;
  /** The app mounts the pick dialog (web zone only); elsewhere there is nothing to open. */
  hosted: boolean;
  /** The floating card stays hidden until this moment (ms) — the next draw. */
  dismissedUntil: number;
  setOpen: (open: boolean) => void;
  setHosted: (hosted: boolean) => void;
  dismiss: (until: number) => void;
}

export const useDailyCardStore = create<DailyCardState>()(
  persist(
    (set) => ({
      open: false,
      hosted: false,
      dismissedUntil: 0,
      setOpen: (open) => set({ open }),
      setHosted: (hosted) => set({ hosted }),
      dismiss: (until) => set({ dismissedUntil: until }),
    }),
    {
      name: 'daily-card-widget',
      storage: createJSONStorage(() => localStorage),
      partialize: ({ dismissedUntil }) => ({ dismissedUntil }),
    },
  ),
);
